module.exports = __webpack_public_path__ + "static/media/baseMeme15thumb.d80f9c77.jpg";